import type { LoginRequest, TwoFactorSetup, User } from "@/types/AuthModels";
import { apiClient } from "./client";

/**
 * Implements requests for authentication api requests.
 */
export const authApi = {
	/**
	 * Authenticates a user
	 * @param credentials user email and password
	 * @returns user information if 2fa is disabled.
	 */
	login: (credentials: LoginRequest): Promise<User> =>
		apiClient.post<User>("/api/auth/auth/login", credentials),
	/**
	 * Authenticates a user with 2fa enabled.
	 * @param code otp generated by authentication app.
	 * @returns @see User
	 */
	verify2fa: (code: string): Promise<User> =>
		apiClient.post<User>("/api/auth/twofactor/verify", code),
	/**
	 * Logs out user by reading the userId present in request.
	 * @returns
	 */
	logout: (): Promise<void> => apiClient.post<void>("/api/auth/auth/logout"),
	/**
	 * Initial request to setup two factor authentication
	 * @returns Two factor secret
	 */
	setup2fa: (): Promise<TwoFactorSetup> =>
		apiClient.get<TwoFactorSetup>("/api/auth/twoFactor/setup"),
	/**
	 * Initial Two factor authentication setup request.
	 * @param code otp code from authentication app.
	 */
	confirm2fa: (code: string) => apiClient.post("/api/auth/twoFactor/setup/confirm", code),
};
